/**
 * -------------------------------------------------------------------------
 * CONFIGURATION
 * -------------------------------------------------------------------------
 */
const LOGO_CONFIG = {
  SELECTOR: ".template--index .logo-box .logo",
  BREAKPOINT: 1280,
  MAX_SCALE: 10.0,
  DESKTOP_TOP_OFFSET: 48,
  SCROLL_SPEED: 0.11,
  ANIMATE_CLASS_POS: 200
};

// Math Helper Function (Linear Interpolation)
function l(t, e, i, n, o, r) {
    var s = ((t - e) / (i - e)) * (o - n) + n;
    return r ? (n < o ? Math.max(Math.min(s, o), n) : Math.max(Math.min(s, n), o)) : s;
}

function updateLogoTransform() {
    var winWidth = window.innerWidth;
    var scrollTop = jQuery(window).scrollTop();
    var logoElement = document.querySelector('.header-logo');

    if (!logoElement) return;

    // Mobile
    if (winWidth < LOGO_CONFIG.BREAKPOINT) {
        var availableWidth = winWidth - 120;
        var svgNaturalWidth = 207;
        if (availableWidth < svgNaturalWidth) {
            var mobileScale = availableWidth / svgNaturalWidth;
            logoElement.style.transform = 'scale(' + mobileScale + ')';
            logoElement.style.transformOrigin = 'left center';
        } else {
            logoElement.style.transform = '';
            logoElement.style.transformOrigin = '';
        }
        if (scrollTop > LOGO_CONFIG.ANIMATE_CLASS_POS) {
            jQuery('.logo-box .logo').addClass("animated");
        } else {
            jQuery('.logo-box .logo').removeClass("animated");
        }
        return;
    }

    // Desktop: SVG-Style zurücksetzen
    logoElement.style.transform = '';
    logoElement.style.transformOrigin = '';

    var tY = LOGO_CONFIG.DESKTOP_TOP_OFFSET;
    var rawScale = (document.body.clientWidth - tY) / logoElement.clientWidth;
    var targetScale = Math.min(rawScale, LOGO_CONFIG.MAX_SCALE);

    var scrollFactor = LOGO_CONFIG.SCROLL_SPEED * (winWidth - tY);
    if (scrollFactor <= 0) scrollFactor = 1;

    var t = 1 - (scrollTop / scrollFactor);

    // FIX Safari: transform-origin direkt per nativem Style setzen
    var logoSelector = document.querySelector(LOGO_CONFIG.SELECTOR);
    if (logoSelector) {
        logoSelector.style.webkitTransformOrigin = 'top center';
        logoSelector.style.transformOrigin = 'top center';
    }

    jQuery(LOGO_CONFIG.SELECTOR).css({
        'transform': "translateY(" + l(t, 0, 1, 0, tY, true) + "px) scale(" + l(t, 0, 1, 1, targetScale, true) + ")"
    });

    if (scrollTop > LOGO_CONFIG.ANIMATE_CLASS_POS) {
        jQuery('.logo-box .logo').addClass("animated");
    } else {
        jQuery('.logo-box .logo').removeClass("animated");
    }
}

jQuery(window).on('load resize scroll', function() {
    updateLogoTransform();
});
updateLogoTransform();

if (jQuery(window).width() < LOGO_CONFIG.BREAKPOINT){
    setTimeout(function(){
      jQuery('.logo-box .logo').addClass("animated");
    }, 3000);
}